import React from 'react';

import {Paper, Typography, Stack, Box} from 'views/components';
import {Check, WavingHandOutlined} from 'views/icons';
import {Translate} from 'views/module';

const NextStepsSection = (props) => {
  return (
    <Paper
      sx={{
        px: '16px',
        py: '24px',
        borderRadius: '24px',
        boxShadow: 'none',
        backgroundColor: '#FFFFFF',
      }}
    >
      <Stack sx={{gap: '17px'}}>
        <Typography sx={{fontSize: '32px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', letterSpacing: '-2%', fontFamily: '"Spectral", serif'}}>
          <Translate expression={'caregivermatchingstep.NextStepsSection.Title'} />
        </Typography>

        <Stack sx={{gap: '24px'}} alignItems='center'>
          <Stack sx={{gap: '4px'}} alignItems='center'>
            <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', letterSpacing: '-2%', fontFamily: '"Spectral", serif'}}>
              <Translate expression={'caregivermatchingstep.NextStepsSection.ReviewTitle'} />
            </Typography>
            <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
              <Translate expression={'caregivermatchingstep.NextStepsSection.ReviewSubtitle'} />
            </Typography>
          </Stack>

          <Box sx={{width: '100%', position: 'relative'}}>
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 'calc(50% + 26px + 8px)',
                top: '50%',
                borderBottom: '1px dashed #DED8D7',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                left: 'calc(50% + 26px + 8px)',
                right: 0,
                top: '50%',
                borderBottom: '1px dashed #DED8D7',
              }}
            />
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
              <Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: '50%',
                  backgroundColor: '#F0EAE5',
                  display: 'grid',
                  placeItems: 'center',
                  zIndex: 1,
                }}
              >
                <WavingHandOutlined sx={{fontSize: 24, color: '#2D2925'}} />
              </Box>
            </Box>
          </Box>

          <Stack sx={{gap: '4px'}} alignItems='center'>
            <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', letterSpacing: '-2%', fontFamily: '"Spectral", serif'}}>
              <Translate expression={'caregivermatchingstep.NextStepsSection.MeetTitle'} />
            </Typography>
            <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
              <Translate expression={'caregivermatchingstep.NextStepsSection.DateNotSet'} />
            </Typography>
          </Stack>

          <Box sx={{width: '100%', position: 'relative'}}>
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 'calc(50% + 26px + 8px)',
                top: '50%',
                borderBottom: '1px dashed #DED8D7',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                left: 'calc(50% + 26px + 8px)',
                right: 0,
                top: '50%',
                borderBottom: '1px dashed #DED8D7',
              }}
            />
            <Box sx={{display: 'flex', justifyContent: 'center'}}>
              <Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: '50%',
                  backgroundColor: '#F0EAE5',
                  display: 'grid',
                  placeItems: 'center',
                  zIndex: 1,
                }}
              >
                <Check sx={{fontSize: 24, color: '#2D2925'}} />
              </Box>
            </Box>
          </Box>

          <Stack sx={{gap: '4px'}} alignItems='center'>
            <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', letterSpacing: '-2%', fontFamily: '"Spectral", serif'}}>
              <Translate expression={'caregivermatchingstep.NextStepsSection.StartTitle'} />
            </Typography>
            <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
              <Translate expression={'caregivermatchingstep.NextStepsSection.DateNotSet'} />
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default React.memo(NextStepsSection);
